import styled from 'styled-components';

/**
 * The unit inside a field, parked exactly where the select parks its chevron
 * (16px from the edge) so the two rows read as a pair.
 *
 * Anchored to the bottom rather than centred on the wrapper, because the
 * wrapper holds the field's label as well - its middle is not the input's.
 * AdminInput's own `suffix` is not used here: it also pads the input on the
 * right, which pushes centred text off centre.
 */
export const FieldSuffix = styled.span`
  position: absolute;
  right: 16px;
  bottom: 0;
  height: ${({ theme }) => theme.input.height};
  display: flex;
  align-items: center;
  font-size: 15px;
  color: ${({ theme }) => theme.darkGray};
  pointer-events: none;
`;

/** The pages the lookup read. Underlined so they read as links. */
export const SourceLink = styled.a`
  color: ${({ theme }) => theme.darkGray};
  text-decoration: underline;
  word-break: break-all;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;
